(() => {
  function activateDeepLinks() {
    const category = { '#bulk-custom': 'custom', '#product-question': 'product', '#order-support': 'tracking' }[window.location.hash]
    if (!category) return
    for (const mount of document.querySelectorAll('[data-blt-support-mount]')) {
      const button = mount.querySelector('[data-category="' + category + '"]')
      if (button && button.getAttribute('aria-pressed') !== 'true') button.click()
    }
  }
  function showFallback(mount) {
    mount.innerHTML = '<p>The form could not load just now. Please <a href="/apps/track-order/support">try our support page</a> or email <a href="mailto:admin@bltacgroup.com">admin@bltacgroup.com</a>.</p>'
  }
  async function mountSupport() {
    for (const mount of document.querySelectorAll('[data-blt-support-mount]')) {
      if (mount.dataset.loaded) continue
      mount.dataset.loaded = 'true'
      const controller = new AbortController()
      const timeout = setTimeout(() => controller.abort(), 30000)
      try {
        const response = await fetch('/apps/track-order/support?fragment=1', { signal: controller.signal })
        if (!response.ok) throw new Error('Support is unavailable')
        const result = await response.json()
        if (typeof result.html !== 'string' || !result.html.includes('data-support-root')) throw new Error('Support is unavailable')
        mount.innerHTML = result.html
        if (!document.querySelector('[data-blt-support-style]')) {
          const style = document.createElement('link')
          style.rel = 'stylesheet'
          style.href = '/apps/track-order/support?asset=style&v=1'
          style.dataset.bltSupportStyle = 'true'
          document.head.append(style)
        }
        await new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.src = '/apps/track-order/support?asset=script&v=1'
          script.addEventListener('load', activateDeepLinks)
          script.onload = resolve
          script.onerror = () => reject(new Error('Support is unavailable'))
          controller.signal.addEventListener('abort', () => reject(new Error('Support took too long to load')), { once: true })
          if (controller.signal.aborted) { reject(new Error('Support took too long to load'))
            return }
          mount.append(script)
        })
      } catch { showFallback(mount) }
      finally { clearTimeout(timeout) }
    }
  }
  window.addEventListener('hashchange', activateDeepLinks)
  mountSupport()
  document.addEventListener('shopify:section:load', mountSupport)
})()
